import axios from 'axios'

const service = axios.create({
  timeout: 300000
})

export default service
